import React from 'react';
import { Link } from 'react-router-dom';
import { TutoInscriptionContenu } from '../components/TutoInscription';

// Iter 822 — page publique partageable (WhatsApp / e-mail) : /tuto-inscription
export default function TutoInscription() {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="page-tuto-inscription">
      <div className="max-w-2xl mx-auto px-4 py-6 space-y-4">
        <div className="bg-[#1E3A5F] text-white rounded-2xl p-5 shadow">
          <p className="text-xs font-bold text-[#79c9ea]">Rhône Alpes Amitié Voyages</p>
          <h1 className="text-xl sm:text-2xl font-bold mt-1">📖 Inscription et règlement du voyage</h1>
          <p className="text-sm text-sky-100 mt-1">Bonjour ! Voici comment ça marche, en 3 étapes.</p>
        </div>
        <TutoInscriptionContenu />
        <div className="flex gap-2 flex-wrap">
          <Link to="/inscription" className="flex-1 text-center bg-[#1E3A5F] text-white font-bold rounded-xl px-4 py-3" data-testid="tuto-page-inscription-btn">📝 Remplir mon formulaire</Link>
          <Link to="/moi" className="flex-1 text-center border-2 border-[#1E3A5F] text-[#1E3A5F] font-bold rounded-xl px-4 py-3" data-testid="tuto-page-espace-btn">👤 Mon espace adhérent</Link>
        </div>
        <p className="text-xs text-gray-500 text-center">Une question ? WhatsApp : 06 60 41 62 18 — L'équipe Rhône Alpes Amitié Voyages</p>
      </div>
    </div>
  );
}
